/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";

export class OverlayDropinsView extends Component {
  _getOverlayDropins() {
    const overlayDropins = this.props.overlayDropins;
    const renderDropins = overlayDropins.map(dropinObj => {
      const OverlayDrop = dropinObj.dropin;
      return <OverlayDrop apis={dropinObj.api} config={dropinObj.config} />;
    });
    return renderDropins;
  }

  render() {
    const overlayDropins = this._getOverlayDropins();
    return this.props.isPreviewMounted ? <div className="OverlayDropinsView">{overlayDropins}</div> : null;
  }
}

OverlayDropinsView.defaultProps = {
  overlayDropins: []
};
